import { useCallback } from 'react';
import type { IRecordListModel, ISavedView, PageSize } from '@platform/core/types';
import { viewOfKind } from './viewOfKind';

const SIZES: readonly number[] = [10, 15, 25, 50, 100];

/**
 * Вибір збереженого подання (прототип v4): запам'ятовує подання для пункту меню, скидає сторінку й сортування, бере розмір сторінки
 * подання і відкриває подання його виду (таблиця → «Таблиця», дошка → «Беклог», картки → «Картки»); «Типове подання» — лише скидання.
 */
export function useSelectSavedView(model: IRecordListModel): (view: ISavedView | null) => void {
  const { setState, openView, state } = model;
  return useCallback((view: ISavedView | null) => {
    const size = view?.definition.pageSize;
    setState({ savedViewId: view?.id ?? null, page: 1, sort: '', ...(size && SIZES.includes(size) ? { pageSize: size as PageSize } : {}) });
    const target = view ? viewOfKind(view.kind) : undefined;
    if (target && target !== state.view) openView(target);
  }, [setState, openView, state.view]);
}
